import { Col } from '../grid';
import Base from '../base';
/* istanbul ignore next */
Col.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Col.name, Col);
};

export default Col;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/col/index.js
// module id = null
// module chunks = 